import Nav from 'react-bootstrap/Nav';
import { FC, ReactNode } from 'react';
import { NavProps } from 'react-bootstrap/Nav';
interface TabBarProps extends NavProps {
  onSelect?: (id: string | null) => void;
  defaultSelected?: string;
  children: ReactNode;
}

const TabBar: FC<TabBarProps> = ({
  onSelect,
  children,
  defaultSelected,
  ...props
}) => {
  return (
    <Nav
      justify
      variant="underline"
      onSelect={onSelect}
      {...props}
      defaultActiveKey={defaultSelected}
      className="border-bottom"
    >
      {children}
    </Nav>
  );
};

export default TabBar;
